import { useContext } from 'react';

import { UbbleCheckoutSdkContext } from '../contexts';

export const useIsUbbleCheckoutSdkLoaded = (): { loaded: boolean } => {
  return useContext(UbbleCheckoutSdkContext);
};
